import { IconProps } from "@/src/sb/business-layer/types"

const SignOut = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 12}
    height={props.height ?? props.size ?? 14}
    viewBox="0 0 12 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99973 2.26506L8.53823 3.06345C10.528 4.21226 11.4982 6.55433 10.9035 8.77368C10.3088 10.993 8.29764 12.5363 6 12.5363C3.70236 12.5363 1.69118 10.993 1.09651 8.77368C0.50184 6.55433 1.47196 4.21226 3.46177 3.06345L3.00027 2.26506C0.648676 3.62275 -0.497825 6.39065 0.204969 9.01351C0.907763 11.6364 3.28461 13.4602 6 13.4602C8.71539 13.4602 11.0922 11.6364 11.795 9.01351C12.4978 6.39065 11.3513 3.62275 8.99973 2.26506ZM5.53841 0.539062H6.46141V7.00002H5.53841V0.539062Z"
      fill={props.color ?? "currentColor"}
    />
  </svg>
)

export default SignOut
